import { render, staticRenderFns } from "./inputTextArea.pug?vue&type=template&id=5b05ee43&lang=pug&external"
import script from "./inputTextArea.js?vue&type=script&lang=js&external"
export * from "./inputTextArea.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b05ee43')) {
      api.createRecord('5b05ee43', component.options)
    } else {
      api.reload('5b05ee43', component.options)
    }
    module.hot.accept("./inputTextArea.pug?vue&type=template&id=5b05ee43&lang=pug&external", function () {
      api.rerender('5b05ee43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/text-area/index.vue"
export default component.exports